import React from 'react';

import CountryInfo from '../CountryInfo';

const BPI_FRANCE_SECTION = {
    title: 'Soutien aux Entreprises de BpiFrance',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">
                Plan d&apos;actions pour les entreprises impactées :
            </p>
            <ul>
                <li>
                    Octroi de la garantie Bpifrance, pour les prêts de
                    trésorerie accordés par les banques privées françaises aux
                    entreprises affectées par les conséquences du Coronavirus.
                </li>
                <li>
                    Prolongation des garanties classiques des crédits
                    d’investissement, pour accompagner les réaménagements opérés
                    par les banques, sans frais de gestion.
                </li>
                <li>
                    Réaménagement des crédits moyen et long terme pour les
                    clients Bpifrance, sur demande motivée par le contexte.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Coronavirus : Bpifrance active des mesures exceptionnelles de soutien aux entreprises',
            url: 'https://www.bpifrance.fr/A-la-une/Actualites/Coronavirus-Bpifrance-active-des-mesures-exceptionnelles-de-soutien-aux-entreprises-49113',
        },
    ],
};

const LOAN_SECTION = {
    title: 'Prêts Atout Bpifrance',
    content: (
        <div>
            <p>
                Dans le cadre du plan de relance de soutien d&apos;urgence aux
                entreprises, avec ses partenaires (Régions, banques, etc.),
                Bpifrance lance des prêts de soutien à la trésorerie.
            </p>
            <br />
            <p>
                Prêts sans garantie, sans sûretés réelles sur les actifs de la
                société ou de son dirigeant, ils sont dédiés aux TPE, PME, ETI
                qui traversent un moment difficile lié à la crise sanitaire
                COVID-19.
            </p>
            <br />
            <p>
                Avec les Régions, le prêt Rebond de 10 à 300 000€, bonifié sur
                une durée de 7 ans avec 2 ans de différé.
            </p>
            <br />
            <p>
                Le prêt Atout, jusqu’à 5M€ pour les PME, 30M€ pour les ETI,
                octroyé sur une durée de 3 à 5 ans avec un différé
                d’amortissement.
            </p>
        </div>
    ),
    links: [
        {
            title: 'Tout savoir sur les Prêts Atout Bpifrance',
            url: 'https://www.bpifrance.fr/Toutes-nos-solutions/Prets/Prets-sans-garantie/Pret-Atout',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'France',
    lastUpdated: 'March 27, 2020',
    introSection: (
        <div>
            <p>
                <strong>
                    Le 25 mars 2020, le Ministère de l&apos;Economie français a
                    mis en ligne un site permettant d&apos;accéder rapidement à
                    toutes les &nbsp;
                    <a
                        href="https://info-entreprises-covid19.economie.gouv.fr/kb"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="eds-text-weight--heavy"
                    >
                        mesures d&apos;urgence pour les entreprises confrontées
                        au Covid-19
                    </a>
                    .
                </strong>
            </p>
            <br />
            <p>
                Pour soutenir les entreprises dont l&apos;activité est impactée
                par le coronavirus, Bpifrance a mis en place une série de
                mesures et un accès dédié pour les renseigner et les orienter
                pour traiter leurs problèmes de trésorerie.
            </p>
        </div>
    ),
    sections: [BPI_FRANCE_SECTION, LOAN_SECTION],
};

const FranceInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default FranceInfo;
